var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.7888,
    height: 24,
    rx: 12,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7505 5.001C9.81899 5.001 8.25049 6.5695 8.25049 8.501C8.25049 10.433 9.81899 12.001 11.7505 12.001C13.682 12.001 15.2505 10.433 15.2505 8.501C15.2505 6.5695 13.682 5.001 11.7505 5.001ZM11.7505 6.001C13.1305 6.001 14.2505 7.1215 14.2505 8.501C14.2505 9.881 13.1305 11.001 11.7505 11.001C10.3705 11.001 9.25049 9.881 9.25049 8.501C9.25049 7.1215 10.3705 6.001 11.7505 6.001Z",
    fill: "#E0333C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75049 18.001H12C12.276 18.001 12.5 18.225 12.5 18.501C12.5 18.777 12.276 19.001 12 19.001H5.25049C4.97449 19.001 4.75049 18.777 4.75049 18.501C4.75049 18.501 4.75049 18.089 4.75049 17.501C4.75049 15.016 6.76499 13.001 9.25049 13.001H12C12.276 13.001 12.5 13.225 12.5 13.501C12.5 13.777 12.276 14.001 12 14.001H9.25049C7.31749 14.001 5.75049 15.568 5.75049 17.501V18.001Z",
    fill: "#E0333C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.001 13.001C14.2075 13.001 12.7515 14.457 12.7515 16.2505C12.7515 18.044 14.2075 19.5 16.001 19.5C17.7945 19.5 19.2505 18.044 19.2505 16.2505C19.2505 14.457 17.7945 13.001 16.001 13.001ZM16.001 14.001C17.2425 14.001 18.2505 15.009 18.2505 16.2505C18.2505 17.492 17.2425 18.5 16.001 18.5C14.7595 18.5 13.7515 17.492 13.7515 16.2505C13.7515 15.009 14.7595 14.001 16.001 14.001Z",
    fill: "#E0333C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5884 13.9505L13.7009 17.838C13.5059 18.033 13.5059 18.35 13.7009 18.545C13.8959 18.7405 14.2129 18.7405 14.4079 18.545L18.2954 14.6575C18.4909 14.4625 18.4909 14.1455 18.2954 13.9505C18.1004 13.7555 17.7834 13.7555 17.5884 13.9505Z",
    fill: "#E0333C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.e8ddad622793138f372a52494015816d.svg";
export { ForwardRef as ReactComponent };